// extracted by mini-css-extract-plugin
export var btn = "N_mY K_ww K_wj d_bz d_bP d_bD d_dw";
export var full = "N_xk d_w d_H";